import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { useTheme } from '../../Themes';
import VFText from '../../VFText';

import styles from './CircularItem.Styles';

function CircularItem({ option, isActive, onPress, localize, ...props }) {
  const theme = useTheme();
  return (
    <TouchableWithoutFeedback
      onPress={onPress}
      {...props}
      testID={FoundationTestKeys.selectionListCircularItemTO}
    >
      <View
        style={[styles.itemContainer(theme), isActive ? styles.selectedItemContainer : null]}
        testID={FoundationTestKeys.selectionListCircularItemView}
      >
        <VFText
          style={[styles.item, isActive ? styles.selectedItem(theme) : null]}
          localize={localize}
          i18nKey={option?.toString()}
          testKey={FoundationTestKeys.selectionListCircularText}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

CircularItem.defaultProps = {
  localize: false,
};

CircularItem.propTypes = {
  option: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  onPress: PropTypes.func,
  localize: PropTypes.bool,
};

export default CircularItem;
